// extracted by mini-css-extract-plugin
export default {"fullWidth":"yq-z","image":"zq-z","lazyLoadPicture":"Aq-z","lazyLoadSpinner":"Bq-z","lazyLoadSpin":"Cq-z","lazyLoadImage":"Dq-z","hasStyledAspectRatio":"Eq-z"};